import { createRoot } from 'react-dom/client';
import 'simplebar-react/dist/simplebar.min.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/700.css';
import '@fontsource/cormorant/400.css';
import '@fontsource/jetbrains-mono/400.css';
import App from 'containers/App/App';
import 'utils/guardDomAgainstTranslate';

// A deploy replaced the build a tab already has loaded; the stale chunk it's requesting
// no longer exists, so reload once to pick up the new one instead of erroring out.
window.addEventListener('vite:preloadError', () => window.location.reload());

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(<App />);
